import { useQuery } from "@tanstack/react-query";
import { RecordManagement } from "app/class/record-management";
import useUniqueTable from "app/hooks/useUniqueTable";
import queryKeys from "shared/services/queryKeys";

const FORM_ACTION_QUERY_KEY = queryKeys.records.config("sys_form_action", { scope: "session" });

const useFormActions = (tableName: string) => {
    const table = useUniqueTable(tableName);
    const query = useQuery({
        queryKey: FORM_ACTION_QUERY_KEY,
        queryFn: () => new RecordManagement("sys_form_action")
            .paginate(1, 5000)
            .orderBy("order")
            .run(),
        select: (response) => response.data,
        enabled: Boolean(table),
        staleTime: 1000 * 60 * 5,
    });

    return {
        ...query,
        actions: (query.data ?? []).filter(
            (action) => action.for_table === table?.id || !action.for_table
        ),
    };
};

export default useFormActions;
